// TODO: This file was created by bulk-decaffeinate.
// Sanity-check the conversion and remove this comment.
/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
angular.module('landingPage').directive('giAddToggleText', () => ({
  restrict: 'E',

  compile(element, attrs) {
    $('.details .details_link').attr(
      'gi-toggle-text',
      "element.parent().next('ul')"
    );
    $('.question-answer-block h3').attr('gi-toggle-text', '');
  },
}));
